import { render, staticRenderFns } from "./FuTableOperations.vue?vue&type=template&id=470e83e0&"
import script from "./FuTableOperations.vue?vue&type=script&lang=js&"
export * from "./FuTableOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports